import { Directive, HostListener } from '@angular/core';


@Directive({
  selector: '[nxNoScroll], .no-scroll-input',
})
export class PreventNumberInputScrollDirective {

  @HostListener('wheel', ['$event'])
  onWheel(event: Event) {
    if (event.target instanceof HTMLElement) {
      event.target.blur();
    }
  }
}